export type EuralCode = {
  id: number | null
  code: string
  gevaarlijkeCode: string
  isHazardous: boolean
  labels: Record<string, unknown>
}

export type RdCode = {
  id: number
  code: string
  description: string
  shortDescription: string | null
}

export type Product = {
  uuid: string
  id: number | null
  aantalVerpakkingen: number | null
  chemischeSamenstelling: string | null
  createdDate: string // ISO date string
  eenheid: string | null
  euralCode: EuralCode | null
  euralBeschrijving: string | null
  euralGevaarlijk: boolean
  extraOptions: Record<string, unknown> | null
  fysischeEigenschappen: string | null
  gewicht: number | null
  naam: string | null
  omschrijving: string | null
  rdCode: RdCode | null
  statischNummer: string | null
  verpakkingType: string | null
}

export type ApiProduct = Product & {
  gewicht?: number | null
  text?: string
}

export function createEmptyProduct(): Product {
  return {
    uuid: '',
    id: null,
    aantalVerpakkingen: null,
    chemischeSamenstelling: null,
    createdDate: '',
    eenheid: null,
    euralCode: null,
    euralBeschrijving: null,
    euralGevaarlijk: false,
    extraOptions: null,
    fysischeEigenschappen: null,
    gewicht: null,
    naam: null,
    omschrijving: null,
    rdCode: null,
    statischNummer: null,
    verpakkingType: null,
  }
}

export const LABEL_OVERRIDES: Record<string, string> = { rdCode: 'RD-Code' }
export const COLUMN_ORDER = ['naam', 'euralCode', 'rdCode', 'gewicht']
export const EXCLUDED_PRODUCTS_KEYS = [
  'uuid',
  'aantalVerpakkingen',
  'chemischeSamenstelling',
  'createdDate',
  'eenheid',
  'euralBeschrijving',
  'euralGevaarlijk',
  'extraOptions',
  'fysischeEigenschappen',
  'statischNummer',
  'verpakkingType',
  'omschrijving',
  'deleted',
]
